module.exports = __webpack_public_path__ + "img/ueno-top-img.73dbe8f6.png";